/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_AriaInputs */

const en_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI transparency notice`)
};

const de_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis zur KI-Transparenz`)
};

const fr_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis de transparence sur l’IA`)
};

const es_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de transparencia sobre IA`)
};

const it_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviso sulla trasparenza dell’IA`)
};

const nl_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennisgeving over AI-transparantie`)
};

const pl_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacja o przejrzystości AI`)
};

const fi_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälyn läpinäkyvyysilmoitus`)
};

const da_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelelse om AI-gennemsigtighed`)
};

const sv_candidate_ai_notice_aria = /** @type {(inputs: Candidate_Ai_Notice_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelande om AI-transparens`)
};

/**
* | output |
* | --- |
* | "AI transparency notice" |
*
* @param {Candidate_Ai_Notice_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_aria = /** @type {((inputs?: Candidate_Ai_Notice_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_aria(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_aria(inputs)
	if (locale === "es") return es_candidate_ai_notice_aria(inputs)
	if (locale === "it") return it_candidate_ai_notice_aria(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_aria(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_aria(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_aria(inputs)
	if (locale === "da") return da_candidate_ai_notice_aria(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_aria(inputs)
	return en_candidate_ai_notice_aria(inputs)
});